export interface SellEnv {
  supabaseUrl: string;
  supabaseAnonKey: string;
  shopAppUrl: string;
  webAppUrl: string;
}

function required(name: string, value: string | undefined): string {
  if (!value || value.length === 0) {
    throw new Error(`Missing required env var ${name}.`);
  }
  return value;
}

export const env: SellEnv = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL as string),
  supabaseAnonKey: required(
    'VITE_SUPABASE_ANON_KEY',
    import.meta.env.VITE_SUPABASE_ANON_KEY as string,
  ),
  shopAppUrl:
    (import.meta.env.VITE_SHOP_APP_URL as string | undefined) ??
    'https://shop.peptideclients.com',
  webAppUrl:
    (import.meta.env.VITE_WEB_APP_URL as string | undefined) ??
    'https://app.peptideclients.com',
};
